<h2>Product Feed Connections</h2>

<table mat-table [dataSource]="feedService.destinations()" class="mat-elevation-z2">

  <!-- Type -->
  <ng-container matColumnDef="mapping">
    <th mat-header-cell *matHeaderCellDef>Field Mapping</th>
    <td mat-cell *matCellDef="let row"><button mat-raised-button color="primary" (click)="goToMappings(row.code)">
  Configure
</button>
</td>
  </ng-container>

  <!-- Destination Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Platform</th>
    <td mat-cell *matCellDef="let row">{{ row.name }}</td>
  </ng-container>

  <!-- Type -->
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef>Type</th>
    <td mat-cell *matCellDef="let row">{{ row.type }}</td>
  </ng-container>

  <!-- Status -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let row">
      <ng-container *ngIf="getConnectionStatus(row.code) as acc">
        <span class="connected">Connected</span>
      </ng-container>
      <ng-container *ngIf="!getConnectionStatus(row.code)">
        <span class="not-connected">Not Connected</span>
      </ng-container>
    </td>
  </ng-container>

  <!-- Action -->
  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef>Action</th>
    <td mat-cell *matCellDef="let row">

      <ng-container *ngIf="getConnectionStatus(row.code); else showConnect">
        <button mat-stroked-button color="warn" (click)="disconnect(row.code)">
          Disconnect
        </button>
      </ng-container>

      <ng-template #showConnect>
        <button mat-raised-button color="primary" (click)="openConnectDialog(row)">
          Connect
        </button>
      </ng-template>
      
    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="['mapping','name','type','status','action']"></tr>
  <tr mat-row *matRowDef="let row; columns: ['mapping','name','type','status','action'];"></tr>
</table>
